/*
  Bookings API
*/

import axios from 'axios';

// CSRF Token
const authenticityToken = document.getElementsByName('csrf-token')[0].content;
const headers = {
  'X-CSRF-Token': authenticityToken,
  'X-Requested-With': 'XMLHttpRequest',
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const Api = {
  // If 'checkinables' is not passed in, all unit checkinables in the booking will be used
  updateCheckins({ bookingId, checkinables, bookingIdHash }) {
    return axios({
      headers,
      method: 'post',
      url: '/api/checkins',
      data: {
        booking_id: bookingId,
        checkinables,
        booking_id_hash: bookingIdHash,
        device: 'Web',
      },
    });
  },
  notifyGuest(bookingIdHash, params) {
    return axios({
      headers,
      method: 'post',
      url: `/api/bookings/${bookingIdHash}/update_email_confirmation`,
      data: {
        ...params,
      },
    });
  },
  checkInGuests(bookingId, guestIds) {
    return axios({
      headers,
      method: 'post',
      url: `/api/bookings/${bookingId}/checkins`,
      data: {
        guests: guestIds,
        device: 'ID of the device',
      },
    });
  },
  undoCheckedInGuestIds(bookingId, guestIds) {
    return axios({
      headers,
      method: 'delete',
      url: `/api/bookings/${bookingId}/checkins`,
      data: {
        guests: guestIds,
        device: 'ID of the device',
      },
    });
  },
};

export default Api;
